import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3439db10")

_pushScopeId("data-v-3439db10")
const _hoisted_1 = { class: "shoppinglist-recommendation-list" }
const _hoisted_2 = { class: "shoppinglist-recommendation-list-scrollarea-contents" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "shoppinglist-recommendation-list-scrollarea-contents-padding" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "shoppinglist-recommendation-list-scrollarea-contents-padding" }, null, -1)
const _hoisted_5 = { class: "shoppinglist-recommendation-list-pageindicator" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingListRecommendationListItem = _resolveComponent("ShoppingListRecommendationListItem")
  const _component_ShoppingListRecommendationPageIndicator = _resolveComponent("ShoppingListRecommendationPageIndicator")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "shoppinglist-recommendation-list-scrollarea",
      ref: "scrollElement",
      onScroll: _cache[1] || (_cache[1] = ($event: any) => (_ctx.recommendScroll($event))),
      onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.touchStart(...args))),
      onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.touchMove(...args))),
      onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.touchEnd(...args)))
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.recommendationList, (item) => {
          return (_openBlock(), _createBlock(_component_ShoppingListRecommendationListItem, {
            class: "shoppinglist-recommendation-list-scrollarea-contents-item",
            key: item.foodId,
            imageUrl: item.imageUrl,
            title: item.title,
            description: item.description,
            id: item.foodId,
            name: item.name,
            recipeId: item.recipeIds[0],
            onClick: _ctx.selectFood,
            onClickRecipe: _ctx.selectRecipe
          }, null, 8, ["imageUrl", "title", "description", "id", "name", "recipeId", "onClick", "onClickRecipe"]))
        }), 128 /* KEYED_FRAGMENT */)),
        _hoisted_4
      ])
    ], 544),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.indicatorList, (indicator) => {
        return (_openBlock(), _createBlock(_component_ShoppingListRecommendationPageIndicator, {
          class: "select-category-item",
          key: indicator.index,
          index: indicator.index,
          isSelected: indicator.isSelected
        }, null, 8, ["index", "isSelected"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})